import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { InternshipListModel } from "../form-model/internship-list-form-data.model";

export class InternshipListGridModel extends InternshipListModel { }

export class InternshipListListingModel extends GridModel<InternshipListGridModel> {
    cardCounts: any[] = [];
    gridModel: any;
    internshipCounts: any = {};
}

export class InternshipListGridPostParams extends GridPostParams {
    reportTypeFlag: number = 1;
    search_keyword: '';
    region_search: string = '';
    batch_search: any = '';
    branch_search: any = '';
    state_search: any = '';
    gender_search: string = ''
    status_search: any = '';
    location_search: any = '';
    type_search: any = '';
    cat_search: any = '';
    scoreFilter: any = '';
    ktStatus: any = '';
    uploadedFilter: any = '';
    semFilter: any = '';
}